import axios, { AxiosRequestConfig } from 'axios';
import { LOGINTOKEN, CONTENTTYPE } from "@/config/const";

const devMode = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const baseUrl = devMode ? 'http://192.168.31.36:8203' : '/platformapi';

const instance = axios.create({
    baseURL: baseUrl,
    timeout: 20000,
    headers: {
        'Content-Type': CONTENTTYPE
    }
});

// 请求拦截器：添加 Token
instance.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);

// 响应拦截器：统一处理返回数据
instance.interceptors.response.use(
    (response) => {
        const { code, data, msg } = response.data;
        if (code === 0) {
            return data;
        }
        return Promise.reject({ code, message: msg || 'Request Failed' });
    },
    (error) => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

/**
 * 封装请求方法
 */
const request = (config: AxiosRequestConfig) => instance(config);

/**
 * 获取过滤词列表
 */
export function getKeywords() {
    return request({
        url: '/api/v1/platform/ai-minutes/keywords',
        method: 'get',
    });
}

/**
 * 添加过滤词
 */
export function addFilterWord(word: string) {
    return request({
        url: '/api/v1/platform/ai-minutes/keywords',
        method: 'post',
        data: { word },
    });
}

/**
 * 删除过滤词
 */
export function deleteFilterWord(id: number | string) {
    return request({
        url: '/api/v1/platform/ai-minutes/keywords/' + id,
        method: 'delete',
    });
}

/**
 * 获取AI纪要列表
 * @param params 
 * @returns 
 */
export function getAiMinutesList(params: object) {
	return request({
		url: '/api/v1/platform/ai-minutes/list',
		method: 'get',
		params,
	});
}
